export default "__VITE_ASSET__C_45oaES__"